import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';

const saveReviewComment = async (
  reviewId: string,
  status: string,
  text: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.patch('/portal/comments/reviews/comment', {
      reviewId,
      comment: {
        status,
        text,
      },
    });
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const deleteReviewComment = async (
  reviewId: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.delete(`/portal/comments/reviews/comment/${reviewId}`);
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const CommentingService = {
  saveReviewComment,
  deleteReviewComment,
};

export default CommentingService;
